import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ValidatorService } from 'src/app/framework/components/form-control-messages/validator.service';
import { SnackBarService } from 'src/app/framework/service/snack-bar.service';
import { Utility } from 'src/app/framework/utils/utility';
import { PatientService } from '../patient.service';

@Component({
  selector: 'app-genome-data-order',
  templateUrl: './genome-data-order.component.html',
  styleUrls: ['./genome-data-order.component.scss']
})
export class GenomeDataOrderComponent implements OnInit {
  genomeDataOrderForm: FormGroup;
  patientId;
  myFocusVar: boolean = false;
  constructor(
    private readonly pservice: PatientService,
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly snackBar: SnackBarService,
    public dialogRef: MatDialogRef<GenomeDataOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }


  ngOnInit() {
    if (!Utility.isEmpty(this.data.patientId)) {
      this.patientId = this.data.patientId;
    }
    this.genomeDataOrderForm = this.fb.group({
      patientId: this.patientId,
      barcode: [null, [Validators.required,Validators.minLength(12), Validators.maxLength(14), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{12,14}$/)]],
      confirmBarcode: [null, [Validators.required,Validators.minLength(12), Validators.maxLength(14), Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{12,14}$/)]],
    }, {
      validator: ValidatorService.mustMatch('barcode', 'confirmBarcode')
    });
  }

  onFocusEvent(event: any){
    this.myFocusVar = true;
  }

  onSubmit(genomeDataOrderForm) {
    if (this.genomeDataOrderForm.valid) {
      this.pservice.placeGenomeDataRequest(this.formatPayload(genomeDataOrderForm)).subscribe((rsp) => {
        this.snackBar.success("Success! Test order has been placed");
        this.dialogRef.close(true);
      }, error => {
        this.showErrorMsg(error, genomeDataOrderForm);
      })
    }
  }

  formatPayload(genomeDataOrderForm) {
    const genomeDataOrderFormRaw = this.genomeDataOrderForm.getRawValue();
    return {
      ...genomeDataOrderFormRaw,
    }
  }
  private showErrorMsg(error: any, genomeDataOrderForm: any) {
    if (error.error.errors) {
      error.error.errors.forEach(element => {
        this.displayError(genomeDataOrderForm, element);
      });
    } else {
      this.snackBar.error(error.error.applicationMessage);
    }
  }
  private displayError(patientForm: any, element: any) {
    patientForm.get(element.field).setErrors({ errorMessage: element.errorMessage });
  }

}
